"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../../ApiManagerAdmin");
var ApiConfig_1 = require("../../config/ApiConfig");
var ApiPromotion = /** @class */ (function (_super) {
    __extends(ApiPromotion, _super);
    function ApiPromotion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_PROMOTION_CODE = "/api/statistics/statisticsPartnerByCode";
        _this.GET_PROMOTION_DAY = "/api/statistics/statisticsPartnerByDate";
        _this.getPromotionDayList = function (accesstoken, startAt, endAt, code, timezone, type) {
            var data = {
                startAt: startAt,
                endAt: endAt,
                code: code,
                timezone: timezone,
                type: type,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_PROMOTION_DAY,
                method: "post",
                data: data,
            });
            return config;
        };
        _this.getPromotionCodeList = function (accesstoken, startAt, endAt, timezone, type, code) {
            var data = {
                startAt: startAt,
                endAt: endAt,
                timezone: timezone,
                type: type,
                code: code,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_PROMOTION_CODE,
                method: "post",
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiPromotion.getInstance = function (initValue) {
        if (!ApiPromotion.classInstance) {
            this.classInstance = new ApiPromotion(initValue);
        }
        return this.classInstance;
    };
    return ApiPromotion;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiPromotion;
